export default function filterNulls<T>(array: (T | null | undefined)[]): T[] {
  return array.filter((x) => typeof x !== "undefined" && x !== null) as T[];
}
